// src/pokerSocket.js
import { io } from 'socket.io-client';

// Берём твою схему как в tournamentSocket:
const WS_BASE =
  process.env.REACT_APP_SOCKET_URL ||
  process.env.REACT_APP_API_URL ||
  window.location.origin;

// Подключаемся к namespace /poker
const pokerSocket = io(`${WS_BASE}/poker`, {
  autoConnect: false,   // подключаюсь вручную после проставления auth
  transports: ['websocket'],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 500,
  reconnectionDelayMax: 2000,
});

// Удобная функция: ставит auth и подключает (как в ensureSocketAuthAndConnect)
export function ensurePokerAuthAndConnect() {
  try {
    const token = localStorage.getItem('token') || '';
    const username = localStorage.getItem('username') || '';
    pokerSocket.auth = token ? { token, username } : { username };
  } catch {}
  if (!pokerSocket.connected && !pokerSocket.connecting) {
    pokerSocket.connect();
  }
}

pokerSocket.on('connect_error', (err) => {
  console.warn('[poker] connect_error:', err?.message || err);
});



// dev-хуки для быстрого теста из консоли
if (typeof window !== 'undefined') {
  window.pokerSocket = pokerSocket;
  window.ensurePokerAuthAndConnect = ensurePokerAuthAndConnect;
}

export default pokerSocket;
